import { useEffect, useMemo, useState } from 'react';
import { TypeProfile } from '../interfaces/permissions';
import { getMyPermissions } from '../services/flow';
import { isDevUnlockRoutesEnabled } from '../utils/devUnlock';

export function useGetProfileType() {
  const [typeProfileActive, setTypeProfileActive] = useState<TypeProfile | null>(null);
  const [permissionsLoading, setPermissionsLoading] = useState(true);
  const devUnlockActive = isDevUnlockRoutesEnabled();

  useEffect(() => {
    async function handleGetMyPermissions() {
      try {
        const token: string | null = localStorage.getItem('gov_access_token');
        if (!token) {
          // Fail-closed fora de DEV unlock; só libera Admin quando unlock estiver ativo.
          setTypeProfileActive(devUnlockActive ? 'Administrador' : null);
          return;
        }
        const { data } = await getMyPermissions(token);
        setTypeProfileActive(data.perfil);
      } catch (err) {
        console.log(err);
        setTypeProfileActive(devUnlockActive ? 'Administrador' : null);
      } finally {
        setPermissionsLoading(false);
      }
    }

    handleGetMyPermissions();
  }, [devUnlockActive]);

  const verifyProfileAllowed = useMemo(() => {
    // Naming legado: true = perfil bloqueado para rotas admin.
    if (devUnlockActive) {
      return false;
    }
    if (!typeProfileActive) {
      return true;
    }
    return (
      typeProfileActive === 'Coordenador' ||
      typeProfileActive === 'Atendente'
    );
  }, [devUnlockActive, typeProfileActive]);

  return { verifyProfileAllowed, permissionsLoading, devUnlockActive };
}
